import { Icon } from "@iconify/react";

// Everything here is on every plan, Free included. Plans differ only in volume.
const FEATURES = [
  "Search",
  "Scrape and batch scrape",
  "Crawl",
  "Map",
  "Parse documents",
  "Templates and presets",
  "Monitors",
  "Stealth Mode in 50+ countries",
  "CAPTCHA solving",
  "Browser actions",
  "AI extraction",
  "REST API and webhooks",
  "Node.js and Python SDKs",
  "MCP server",
];

/** One band of pills, as on spidra.io/pricing. */
export default function IncludedEverywhere() {
  return (
    <div className="rounded-card border border-line bg-surface px-5 py-6 text-center shadow-card sm:px-8">
      <h3 className="text-15 font-medium text-fg">Every plan includes every tool</h3>
      <p className="mt-1 text-13 text-fg-muted">Plans only differ in how much you can use.</p>
      <ul className="mx-auto mt-5 flex max-w-4xl flex-wrap justify-center gap-2">
        {FEATURES.map(f => (
          <li
            key={f}
            className="inline-flex items-center gap-1.5 rounded-full border border-line bg-surface py-1.5 pl-2 pr-3 text-13 text-fg-secondary"
          >
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-primary-subtle text-primary-text">
              <Icon icon="mdi:check-bold" width={10} height={10} aria-hidden="true" />
            </span>
            {f}
          </li>
        ))}
      </ul>
    </div>
  );
}
